module.exports = __webpack_public_path__ + "static/media/152.87cc6f83.jpg";